import React from "react";
import "./component.css";
import "./steper.css"
import Sidebar from "../../Navigation/Sidebar/Sidebar";
import profile from "../../../assests/gprofile.svg";
import Avatar from "../../../assests/Avatar.png";
import infoIcon from "../../../assests/infoIcon.svg";
import phone1 from "../../../assests/phone11.svg";
import mail from "../../../assests/mail.svg";
import dateTime from "../../../assests/dateTime.svg";
import city from "../../../assests/city.svg";
import kiosk from "../../../assests/kiosk.svg";
import vm from "../../../assests/vm.svg";
import leftArrow from "../../../assests/leftArrow.svg";
import { useNavigate } from "react-router-dom";
import Table from "react-bootstrap/Table";
import itemDetails from "../../../assests/itemDetails.svg";
import refund from "../../../assests/refund.svg";
import success from "../../../assests/success.svg";
import cross from "../../../assests/cross.svg";
import panding from "../../../assests/panding.svg";
import LoadingSpinner from "../../Loading/component";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import moment from "moment-timezone";
import { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import cancel from "../../../assests/cancel.svg";
import Box from "@mui/material/Box";
import refundSucessIcon from "../../../assests/refundSuccessIcon.gif"
import notrequired from "../../../assests/notrequired.svg"
import refundschdulesuccess from "../../../assests/refundschdulesuccess.svg"
import upi from "../../../assests/upi.svg"
import indicator from "../../../assests/indictor.svg"
import refundNotreq from "../../../assests/refundNotreq.svg"
import checkIconGreen from "../../../assests/checkIconGreen.svg"
import emptyCircleIcon from "../../../assests/emptyCircleIcon.svg"
import refund_upon from "../../../assests/refund_upon.svg"
import refund_success from "../../../assests/refund_success.svg"
import failedrefundicon from "../../../assests/failedrefundicon.svg"
import walletIcon from "../../../assests/walletIcon.svg"
import bankcard from "../../../assests/bankcard.svg"

export const OrdersViewComp = ({
  data,
  loading,
  show,
  handleClose,
  handleShow,
  handleSubmit,
  issue,
  handleIssueChange,
  selectedIssue,
  handleIssueTextChange,
  handleCopyInfo,
  orderStatus,
  fetchOrderStatus,
}) => {
  const refundDetails = orderStatus && orderStatus || [];


  const [showDetails, setShowDetails] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(null);
  const createdTime = moment(data && data.created_at);
  const currentTime = moment();
  const timeDifferenceInSeconds = currentTime.diff(createdTime, "seconds");
  const initialRemainingTime = Math.max(0, 35 * 60 - timeDifferenceInSeconds);
  const [remainingTime, setRemainingTime] = useState(0);
  const [dialogData, setDialogData] = useState(null);

  const handleOpenStatusModal = (
    orderId,
    refundAmount,
    pgName,
    resultStatus,
    resultMsg
  ) => {
    const selectedRefundItem = {
      orderId: orderId,
      refundAmount: refundAmount,
      pgName: pgName,
      resultStatus: resultStatus,
      resultMsg: resultMsg,
    };

    setDialogData(selectedRefundItem);
    setShowStatusModal(true);

    fetchOrderStatus();
  };

  const handleCloseStatusModal = () => {
    setShowStatusModal(false);
  };



  const statusConfig = {
    REFUND_UPON_REQUEST: {
      icon: refund_upon,
      color: "#F28618",
      message: "If the customer did not receive any product, verify and initiate a manual refund.",
      exeptedSatlementMsg: "Expected Settlement Time: once Refund confirm (refund schedule time + 60 minutes)",
      successMSG: "Refund will be processed to your payment source"
    },
    REFUND_SCHEDULED: {
      icon: refundschdulesuccess,
      color: "#14AE78",
      message: " Your refund has been successfully scheduled and will be initiated in 40mins.",
      exeptedSatlementMsg: "Expected Settlement Time: once Refund confirm (refund schedule time + 60 minutes)",
      successMSG: "Refund will be processed to your payment source ."
    },
    REFUND_PROCESSING: {
      icon: refundSucessIcon,
      color: "#FFC107",
      message: "Your refund is being processed by the bank.",
    },
    REFUND_SUCCESSFUL: {
      icon: refund_success,
      color: "#14AE78",
      message: "Refund reference number is 12345678",
      successMSG: "Refund successfully credited to your payment source."
    },
    REFUND_INITIATION_FAILED: {
      icon: notrequired,
      color: "#DC3545",
      message: "kindly refund manually or ask admin to refund by a payment gateway dashboards.",
      successMSG: "Refund will be processed to your payment source.",
      exceptedSTimer: "Expected Settlement Time: after initiation  ",
    },
    REFUND_NOT_REQUIRED: {
      icon: refundNotreq,
      color: "#DC3545",
      message: "If customer has any concern, kindly ask for product image and then initiate manual refund.",
      successMSG: "Refund will be processed to your payment source.",
      exceptedSTimer: "Expected Settlement Time: after initiation  ",
    },
    REFUND_INITIATED: {
      icon: checkIconGreen,
      color: "#DC3545",
      message: " If customer has any concern, kindly ask for product image and then initiate manual refund .",
      successMSG: "Refund will be processed to your payment source.",
      exceptedSTimer: "Expected settlement time(refund initiation time + 60 min or value returned by API) ",
    },
    REFUND_FAILED: {
      icon: failedrefundicon,
      color: "#DC3545",
      message: " refund could not be processed due to a technical issue.",
      successMSG: "Refund will be processed to your payment source.",
      exceptedSTimer: "Expected settlement time(refund initiation time + 60 min or value returned by API) ",
    },
  };


  useEffect(() => {
    if (data && data.created_at) {
      const createdTime = moment(data.created_at);
      const currentTime = moment();
      const maxAllowedTimeInSeconds = 35 * 60;
      const timeDifferenceInSeconds = currentTime.diff(createdTime, "seconds");
      const remainingTimeInSeconds =
        maxAllowedTimeInSeconds - timeDifferenceInSeconds;

      if (remainingTimeInSeconds > 0) {
        setRemainingTime(remainingTimeInSeconds);

        const timer = setInterval(() => {
          setRemainingTime((prevRemainingTime) => {
            const newRemainingTime = prevRemainingTime - 1;
            return newRemainingTime;
          });
        }, 1000);

        return () => {
          clearInterval(timer);
        };
      }
    }
  }, [data]);

  const minutes = Math.floor(remainingTime / 60);
  const seconds = remainingTime % 60;

  const handleShowDetails = () => {
    setShowDetails(true);
  };


  const navigate = useNavigate();

  const arrowClick = (event) => {
    event.preventDefault();
    navigate("/home/ordersview");
  };

  const handleInitiateRefund = () => {

    const pg_name =
      data && data.payment_details && data.payment_details.pg_name !== "null"
        ? data.payment_details.pg_name
        : "";

    const id = data && data.id;

    navigate(`/home/orderview/manualrefund/${pg_name}/${id}`);
  };

  const imgStyle = {
    width: "78px",
    height: "79px",
    borderRadius: "36.22214px",
  };
  return (
    <div className="main-div" style={{ margin: "auto" }}>
      <div>
        <Sidebar />
      </div>

      {loading ? (
        <>
          <LoadingSpinner />
        </>
      ) : (
        <>
          {data && data && (
            <div style={{ margin: "auto", overflow: "auto", height: "100vh", width: "90vw" }}>
              <div>
                <div
                  style={{
                    marginLeft: "72px",
                    marginTop: "10px",
                    display: "flex",
                    justifyContent: "space-between",
                    width: "75vw"
                  }}
                >
                  <div>
                    <h2 style={{ width: "30vw", }}>
                      <img
                        onClick={arrowClick}
                        style={{ width: "22px", cursor: "pointer" }}
                        src={leftArrow}
                        alt=""
                      />{" "}
                      Mini Order ID : {data && data.dcCode}
                    </h2>
                    <h5 style={{ color: "grey" }}>
                      Order ID : {data && data.id}
                    </h5>
                  </div>

                  <div className="user-statusCompleted">
                    <p className="user-status-text">{data && data.status}</p>
                  </div>
                  <div>
                    <Button
                      style={{ fontSize: "14px" }}
                      variant="primary"
                      onClick={handleShow}
                    >
                      {" "}
                      Copy Details
                    </Button>
                  </div>

                  <div>
                    <Button
                      style={{
                        fontSize: "14px",
                        backgroundColor: "#4caf50  ",
                        border: "1px solid #4caf50",
                        padding: "8px",
                      }}

                      onClick={handleInitiateRefund}
                    >
                      Initiate Refund
                    </Button>
                  </div>
                </div>

                <>
                  <Modal show={show} onHide={handleClose}>
                    <Modal.Body>
                      <Form>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlTextarea1"
                        >
                          <Form.Label>Customer issues :</Form.Label>

                          <select
                            id="issue"
                            value={selectedIssue}
                            onChange={handleIssueChange}
                            style={{
                              borderRadius: "10px",
                              marginLeft: "18px",
                              width: "235px",
                              padding: "8px",
                            }}
                          >
                            <option
                              style={{ fontFamily: "Crimson Text" }}
                              value=""
                            >
                              -- Select --
                            </option>
                            <option
                              style={{ fontFamily: "Crimson Text" }}
                              value={issue}
                            >
                              Vending Failed
                            </option>
                            <option
                              style={{ fontFamily: "Crimson Text" }}
                              value={issue}
                            >
                              Product got stuck
                            </option>
                            <option
                              style={{ fontFamily: "Crimson Text" }}
                              value={issue}
                            >
                              Success Unsuccess
                            </option>
                            <option
                              style={{ fontFamily: "Crimson Text" }}
                              value={issue}
                            >
                              Order X got Y
                            </option>
                            <option
                              style={{ fontFamily: "Crimson Text" }}
                              value={issue}
                            >
                              Prices Mismatched
                            </option>
                            <option
                              style={{ fontFamily: "Crimson Text" }}
                              value={issue}
                            >
                              Refilling Request
                            </option>
                            <option
                              style={{ fontFamily: "Crimson Text" }}
                              value={issue}
                            >
                              Machine not working
                            </option>
                            <option
                              style={{ fontFamily: "Crimson Text" }}
                              value={issue}
                            >
                              Tab not workin
                            </option>
                            <option
                              style={{ fontFamily: "Crimson Text" }}
                              value="other"
                            >
                              Other
                            </option>
                          </select>
                          {selectedIssue === "other" && (
                            <Form.Control
                              value={issue}
                              onChange={handleIssueTextChange}
                              as="textarea"
                              rows={3}
                              style={{ marginTop: "20px" }}
                            />
                          )}
                        </Form.Group>
                      </Form>
                    </Modal.Body>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        margin: "10px",
                      }}
                    >
                      <Button
                        variant="secondary"
                        style={{ fontSize: "14px" }}
                        onClick={handleClose}
                      >
                        Close
                      </Button>
                      <Button
                        variant="primary"
                        style={{ fontSize: "14px", marginLeft: "20px" }}
                        onClick={handleSubmit}
                      >
                        Copy Details
                      </Button>
                    </div>
                  </Modal>
                </>

                <div className="orderInformationDiv">
                  <div className="orderCustomerDetails">
                    <div className="orderBasicSecOrder">
                      <img src={profile} alt="" />
                      <p style={{ marginLeft: "10px" }}>Customer Details</p>
                    </div>

                    <div className="backgroundImg">
                      <div>
                        <div
                          style={{
                            width: "28vw",
                            backgroundColor: "white",
                            height: "198px",
                            margin: "auto",
                          }}
                        >
                          <div>
                            <div className="orderDesignationDiv">
                              <img style={imgStyle} src={Avatar} alt="" />
                              <div className="roleHead">
                                <p>
                                  {data &&
                                    data.user_details &&
                                    data.user_details.name}
                                </p>
                              </div>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                margin: "10px",
                                width: "266px",
                                justifyContent: "space-evenly",
                                flexDirection: "column",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  flexDirection: "row",
                                }}
                              >
                                <img
                                  style={{ width: "22px" }}
                                  src={phone1}
                                  alt=""
                                />
                                <p style={{ margin: "12px" }}>
                                  {data && data.phone}
                                </p>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  flexDirection: "row",
                                }}
                              >
                                <img
                                  style={{ width: "22px" }}
                                  src={mail}
                                  alt=""
                                />
                                <p style={{ margin: "12px" }}>
                                  {data &&
                                    data.user_details &&
                                    data.user_details.email}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="orderInfoItem">
                    <div className="orderSecDiv">
                      <div style={{ display: "flex", alignItems: "flex-start" }}>
                        <img src={infoIcon} alt="" />
                        <p style={{ marginLeft: "10px" }}>Order Information</p>
                      </div>
                      <div style={{ marginLeft: "290px" }}>
                        <Button
                          onClick={handleCopyInfo}
                          style={{ margin: "auto", fontSize: "14px" }}
                        >
                          copy info
                        </Button>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",

                        margin: "20px",
                      }}
                    >
                      <div>
                        <div className="orderinfodetailsDiv">
                          <img src={dateTime} alt="" />
                          <p>
                            Date & Time:
                            {moment
                              .utc(data && data.created_at)
                              .tz("Asia/Kolkata")
                              .format("YYYY-MM-DD hh:mm:ss A")}
                          </p>
                        </div>
                        <div className="orderinfodetailsDiv">
                          <img src={city} alt="" />
                          <p>City: {data && data.city}</p>
                        </div>
                        <div className="orderinfodetailsDiv">
                          <img src={city} alt="" />
                          <p>
                            VM Address: {data && data.vmAddress}
                          </p>
                        </div>
                      </div>

                      <div>
                        <div className="orderinfodetailsDiv">
                          <img src={kiosk} alt="" />
                          <p>Order Via: {data && data.source}</p>
                        </div>
                        <div className="orderinfodetailsDiv">
                          <img src={vm} alt="" />
                          <p>VM Name: {data && data.name}</p>
                        </div>
                        <div className="orderinfodetailsDiv">
                          <img src={vm} alt="" />
                          <p>VM ID: {data && data.machine_id}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="itemDetais">
                  <div className="itemDetailsIcon">
                    <img src={itemDetails} alt="" />
                    <p>Items Details</p>
                  </div>
                  <div>
                    <div
                      style={{
                        // width: "1318px",
                        borderRadius: "15px",
                        margin: "auto",
                      }}
                    >
                      <Table
                        striped
                        hover
                        className="scrol1ldown"
                        id="scrollableDiv"
                        style={{
                          height: "260px",
                          overflowY: "auto",
                          display: "block",
                        }}
                      >
                        <thead>
                          <tr>
                            <th>Product</th>
                            <th>Slot Number</th>
                            <th>MRP</th>
                            <th>Offer Price</th>
                            <th>Quantity</th>
                            <th>Total</th>
                            <th>Status</th>
                          </tr>
                        </thead>

                        <tbody>
                          {data &&
                            data.line_items &&
                            data.line_items.length > 0 &&
                            data.line_items.map((item) => (
                              <tr key={item.id}>
                                <td style={{ textAlign: "left" }}>
                                  {item.name}
                                </td>
                                <td style={{ textAlign: "left" }}>
                                  {item.slot_id}
                                </td>
                                <td style={{ textAlign: "left" }}>
                                  {item.mrp}
                                </td>
                                <td style={{ textAlign: "left" }}>
                                  {item.offer_price}
                                </td>
                                <td style={{ textAlign: "left" }}>
                                  {item.item_count}
                                </td>
                                <td style={{ textAlign: "left" }}>
                                  {item.sub_total}
                                </td>
                                <td style={{ textAlign: "left" }}>
                                  <div key={item.id}>
                                    {item.success_count > 0 && (
                                      <>
                                        <span>{item.success_count}</span>{" "}
                                        <img src={success} alt="Success" />
                                      </>
                                    )}
                                    {item.failure_count > 0 && (
                                      <>
                                        <span>{item.failure_count}</span>{" "}
                                        <img src={cross} alt="Failure" />
                                      </>
                                    )}
                                    {item.vend_remaining_count > 0 && (
                                      <>
                                        <span>{item.vend_remaining_count}</span>{" "}
                                        <img src={panding} alt="Pending" />
                                      </>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>

                <div >
                  <div className="paymentDetails">
                    <div className="paymentIconDiv">
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <img src={refund} alt="" />
                        <p>Payment Details</p>
                      </div>

                      <div>
                        <Button variant="outline-success" style={{ fontSize: "14px" }} onClick={() => {
                          handleOpenStatusModal()
                        }}>Check Refund Status</Button>
                      </div>
                    </div>

                    <div className="itemDetailsPayment">
                      <div className="paymentSucces">
                        <div className="logoRefund">
                          <h3>₹ {data && data.amount}</h3>
                        </div>

                        <div className="paymentItemsDetailsDiv">
                          <div>
                            <p style={{ fontWeight: "bold" }}>ID</p>
                            {data &&
                              data.payment_details &&
                              data.payment_details.id}
                          </div>
                          <div>
                            <p style={{ fontWeight: "bold" }}>Status</p>
                            {data &&
                              data.payment_details &&
                              data.payment_details.status}
                          </div>
                          <div>
                            <p style={{ fontWeight: "bold" }}>Date & Time</p>
                            {moment
                              .utc(
                                data &&
                                data.payment_details &&
                                data.payment_details.updated_at
                              )
                              .tz("Asia/Kolkata")
                              .format("YYYY-MM-DD hh:mm:ss A")}
                          </div>
                          <div>
                            <p style={{ fontWeight: "bold" }}>
                              Payments Gateway
                            </p>
                            {data &&
                              data.payment_details &&
                              data.payment_details.pg_name}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <Dialog open={showStatusModal} style={{ width: "100vw", height: "93vh", borderRadius: "26px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",

                    }}
                  >

                    <DialogTitle style={{ display: "flex", flexDirection: "column" }}>
                      <p style={{ fontWeight: "600" }}> Refund status </p>

                    </DialogTitle>

                    <DialogTitle>
                      <img
                        onClick={() => handleCloseStatusModal()}
                        src={cancel}
                        alt=""
                        title="Click to cancel"
                        style={{ cursor: "pointer" }}
                      />
                    </DialogTitle>
                  </div>

                  <DialogContent
                    style={{
                      width: "39vw",
                      height: "90vh",
                      borderRadius: "16px",
                      display: "flex",
                      alignItems: "center",
                      margin: "auto",

                    }}
                  >
                    {loading ? (
                      <>
                        <LoadingSpinner />
                      </>
                    ) : (
                      <Box
                        style={{
                          width: "100vw",
                          border: "2px dashed #FFB93180",
                          borderStyle: "dashed",
                          height: "70vh",
                          borderRadius: "10px",
                          // padding: "20px",
                          overflowY: "auto",
                        }}
                      >
                        {refundDetails?.refundDetailInfoList && refundDetails.refundDetailInfoList.length > 0 ? (
                          refundDetails.refundDetailInfoList.map((refund, index) => {
                            const isStepperView =
                              refund.status === "REFUND_INITIATED" ||
                              refund.status === "REFUND_SUCCESSFUL";

                            const status = statusConfig[refund.status] || statusConfig.DEFAULT;

                            return (
                              <div className="bordered-box" key={index}>
                                <p className="order-id">
                                  Order ID: <span className="bold">{refundDetails.orderId || "N/A"}</span>
                                </p>

                                {isStepperView ? (
                                  <>
                                    <div className="status-1">

                                      <div className="status-row">
                                        <img src={checkIconGreen} alt="Confirmed" className="status-iconstepper" />
                                        <div>
                                          <p className="status-textstepper bold">Refund Initiated</p>
                                          <p className="status-subtextstepper">

                                            <span>{moment.utc(refund.paymentTime).local().format("D MMM YYYY, h:mm A")}</span>
                                          </p>
                                        </div>
                                      </div>


                                      <div className="status-row">
                                        <img
                                          src={refund.status === "REFUND_SUCCESSFUL" ? checkIconGreen : emptyCircleIcon}
                                          alt="Status Icon"
                                          className="status-iconstepper"
                                        />
                                        <div>
                                          {refund.status === "REFUND_SUCCESSFUL" ? (
                                            <>
                                              <p className="status-textstepper success-text">Refund Successful</p>
                                              <p className="status-subtextstepper success-text">
                                                {moment.utc(refund.refundCreditTime).local().format("D MMM YYYY, h:mm A")}
                                              </p>
                                            </>
                                          ) : (
                                            <>
                                              <p className="status-textstepper ">Refund Processing By Bank</p>
                                              <p className="status-subtextstepper disabled-text">
                                                Expected settlement time:{" "}
                                                {refund.refundCreditExpectedTime ? (
                                                  moment
                                                    .utc(refund.refundCreditExpectedTime)
                                                    .add(60, "minutes")
                                                    .local()
                                                    .format("D MMM YYYY, h:mm A")
                                                ) : (
                                                  "Refund initiation time + 60 min"
                                                )}
                                              </p>
                                            </>
                                          )}
                                        </div>
                                      </div>
                                    </div>


                                  </>
                                ) : (
                                  <>
                                    <div className="status-section">
                                      <div className="status-icon">
                                        <img src={status.icon} alt="Status Icon" />
                                      </div>
                                      <p className="status-text" style={{ color: status.color }}>
                                        {refund.status.replaceAll("_", " ")}
                                      </p>
                                      <p className="status-subtext">
                                        <img src={indicator} alt="Indicator" /> {status.message}
                                      </p>
                                    </div>
                                  </>
                                )}

                                <div className="info-card">
                                  {/* Paid Amount Section (Always Show) */}
                                  <p className="info-text">
                                    Paid Amount: <span className="bold">₹ {refund.paidAmount || "N/A"}</span>
                                  </p>
                                  <p className="info-subtext">
                                    {refund.paymentTime
                                      ? moment.utc(refund.paymentTime).local().format("MMM D, YYYY, h:mm A")
                                      : "N/A"}
                                  </p>

                                  <p className="info-subtext">
                                    Transaction ID: {refund.transactionId || "N/A"}
                                  </p>

                                  <hr />


                                  {refund.status !== "REFUND_NOT_REQUIRED" && (
                                    <>
                                      <p className="info-text">
                                        {refund.status === "REFUND_FAILED" ? "Refund Failed Amount" : "Refund Amount"}:
                                        <span className="bold">₹ {refund.refundAmount || "N/A"}</span>
                                      </p>
                                      {refund.status === "REFUND_INITIATED" && (
                                        <p className="info-subtext in-process-text">In Process</p>
                                      )}

                                      {refund.status === "REFUND_SCHEDULED" && (
                                        <p className="info-subtext">{status.exeptedSatlementMsg}</p>
                                      )}

                                      {refund.status === "REFUND_INITIATION_FAILED" ? (
                                        <p className="info-subtext">{status.exceptedSTimer}</p>
                                      ) : refund.refundInitiatedTime === null &&
                                        refund.status === "REFUND_UPON_REQUEST" ? (
                                        <p className="info-subtext">{status.exeptedSatlementMsg}</p>
                                      ) : refund.refundCreditTime ? (
                                        <>
                                          <p className="info-subtext">
                                            {refund.refundCreditTime
                                              ? moment.utc(refund.refundCreditTime).local().format("MMM D, YYYY, h:mm A")
                                              : ""}
                                          </p>
                                          {refund.refundId && (
                                            <p className="info-subtext">Refund ID: {refund.refundId}</p>
                                          )}
                                        </>
                                      ) : refund.refundId ? (
                                        <p className="info-subtext">Refund ID: {refund.refundId} </p>
                                      ) : null}

                                      <p className="info-subtext">
                                        {refund.refundCreditExpectedTime
                                          ? moment.utc(refund.refundCreditExpectedTime).local().format("MMM D, YYYY, h:mm A")
                                          : ""}
                                      </p>

                                      <hr />
                                    </>
                                  )}


                                  {!["REFUND_INITIATION_FAILED", "REFUND_FAILED", "REFUND_NOT_REQUIRED"].includes(refund.status) && (
                                    <>
                                      <p className="info-text">
                                        Payment Method:
                                        <img
                                          src={
                                            refund.payMethod?.toLowerCase() === "upi"
                                              ? upi
                                              : refund.payMethod?.toLowerCase() === "wallet"
                                                ? walletIcon
                                                : bankcard
                                          }
                                          alt={refund.payMethod}
                                          style={{ marginLeft: "5px" }}
                                        />
                                        {" "}
                                        {refund.payMethod ? refund.payMethod.toUpperCase() : "N/A"}
                                      </p>
                                      <p className="info-subtext">{status.successMSG}</p>
                                    </>
                                  )}
                                </div>

                              </div>
                            );
                          })
                        ) : (
                          <p className="no-data-message">No refund details available.</p>
                        )}
                      </Box>
                    )}
                  </DialogContent>
                </Dialog>

                {/* <div className="itemDe111tais1">
                  <div className="itemDetailsIcon1">
                    <div
                      style={{
                        width: "140px",
                        display: "flex",
                        justifyContent: "space-around",
                      }}
                    >
                      <img src={refund} alt="" />
                      Refund Details
                    </div>
                    <div> {data.refund_details.length} Refund </div>
                  </div>

                  <div>
                    <Table
                      striped
                      hover
                      className="scrol1ldown"
                      id="scrollableDiv"
                      style={{
                        height: "260px",
                        overflowY: "auto",
                        display: "block",
                      }}
                    >
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Date & Time</th>
                          <th>Amount</th>
                          <th>PG</th>
                          <th>Reason</th>
                          <th> Type</th>

                          <th> Status</th>
                          <th>View Details</th>
                        </tr>
                      </thead>

                      <tbody>
                        {data.refund_details.map((refundItem) => (
                          <tr key={refundItem.id}>
                            <td>{refundItem.id}</td>

                            <td style={{ fontSize: "10px" }}>
                              {moment
                                .utc(refundItem.updated_at)
                                .tz("Asia/Kolkata")
                                .format("YYYY-MM-DD hh:mm:ss A")}
                            </td>

                            <td>{refundItem.amount}</td>
                            <td>{refundItem.pg_name}</td>
                            <td>
                              <span
                                style={{
                                  color: "#FF5050",
                                  fontSize: "14px",
                                  backgroundColor: "#FF000014",
                                  width: "100px",
                                  padding: "8px 2px 8px 2px",
                                  borderRadius: "8px",
                                  fontSize: "14px",
                                }}
                              >
                                {refundItem.reason}
                              </span>
                            </td>
                            <td>{refundItem.status}</td>
                            <td>{refundItem.refundStatus}</td>
                            <td>
                              {" "}
                              <img
                                src={refillEye}
                                onClick={() =>
                                  handleOpenStatusModal(
                                    refundItem.id,
                                    refundItem.amount,
                                    refundItem.pg_name,
                                    refundItem.result_status,
                                    refundItem.result_msg
                                  )
                                }
                                alt="View"
                                style={{ cursor: "pointer" }}
                              />
                              <Button onClick={() => {
                                handleOpenStatusModal()
                              }}>Check status</Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    </div>
                    
                </div> */}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};
